import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import schema from 'components/Source/Search/schema';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import { SourcesQuery } from 'components/Source/Form/graphql';
import NavigationProvider from 'components/Navigation/Provider';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const SourceForm = React.lazy(() => import('components/Source/Form/Form'));

function ScreensSourceForm(params: Readonly<RoutePrivateProps>) {
  const id = params.id ? Number(params.id) : null;

  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>{params.id ? 'Edit' : 'Create'} Source</DocumentTitle>
      <NavigationProvider
        id={id}
        buildUrl={(nid: string) => `/sources/${nid}/edit`}
        schema={schema}
        query={SourcesQuery}
      >
        <Suspense fallback={<UILoader />}>
          <SourceForm id={id} key={id} />
        </Suspense>
      </NavigationProvider>
    </BaseLayout>
  );
}

export default ScreensSourceForm;
